import {MutationTree} from 'vuex';
import {ActionUsersState} from '@/store/user_management/action_users/types';

export const mutations: MutationTree<ActionUsersState> = {
  setActionUsers(state, data) {
    state.actionUsers = data;
  },
  pushActionUsers(state, data) {
    state.actionUsers = state.actionUsers.concat(data);
  },
  setActionUserItem(state, data) {
    state.actionUserItem = data;
  },
  setObjectTypes(state, data) {
    state.objectTypes = data;
  },
  setPartnerUsersPages(state, data) {
    state.partnerUsersPages = data;
  },
  setPartnerUsersPagesItem(state, data) {
    state.partnerUsersPagesItem = data;
  },
};
